import React, { useEffect, useState } from 'react';
import StyledH6Heading from '../../../common/components/styledH6Heading/StyledH6Heading';
import StyledMdText from '../../../common/components/styledMdText/StyledMdText';
import StyledXlText from '../../../common/components/styledXlText/StyledXlText';
import { content } from '../../../data'
import ProjectsCard from '../../../components/projectsCard/ProjectsCard';
import { useMintingStateContext } from "../../../context/CrowdfundingContext"
import { useStateContext } from "../../../context/StateContext"
import { Error } from '../../../components/toast/Error';
import Button from '../../../components/button/Button';
import { useAccount } from 'wagmi';
import { useNavigate } from 'react-router-dom';
import Modal from '../../../components/modal/Modal';
import StyledSmText from '../../../common/components/styledSmText/StyledSmText';
import StyledXsText from '../../../common/components/styledXsText/StyledXsText';
import { Success } from '../../../components/toast/Success';

const ProjectsSection = () => {

    const { fetchAllProjects, checkIsVolunteer, giveDonation } = useMintingStateContext();
    const { isValid, donateModalShow, currentProject, setDonateModalShow } = useStateContext()
    const currentTimestamp = new Date().getTime()

    const filterOptions = content?.filterOptions;
    const account = useAccount()
    const navigate = useNavigate()

    // State variables
    const [projects, setProjects] = useState([])
    const [donatedValue, setDonatedValue] = useState(null)
    const [activeFilter, setActiveFilter] = useState('All');
    const [searchQuery, setSearchQuery] = useState('');

    const handleFilterClick = (filter) => {
        setActiveFilter(filter);
    };

    const getAllProjects = async () => {
        try {
            const response = await fetchAllProjects();
            setProjects(response)
        }
        catch (error) {
            console.log("��� ~ getAllProjects ~ error:", error)
        }
    }

    const handleAddProject = async () => {
        try {
            const response = await checkIsVolunteer(account.address)
            if (response === true) {
                navigate('/add-project')
            }
            else {
                Error({ text: "Failed!", message: "You are not a volunteer" })
            }
        }
        catch (error) {
            console.log("��� ~ handleAddProject ~ error:", error)
        }
    }

    // Filter projects based on search query and active filter
    const filteredProjects = projects.filter((project) => {
        const projectNameMatch = project.projectName.toLowerCase().includes(searchQuery.toLowerCase());
        const tagsMatch = project.tags.some(tag => tag.toLowerCase().includes(searchQuery.toLowerCase()));

        // Check if the project matches the search query
        const searchMatch = projectNameMatch || tagsMatch;

        // Filter based on active filter
        if (activeFilter === 'All') {
            return searchMatch;
        } else if (activeFilter === 'Past Projects') {
            return searchMatch && project.withdawalStatus === true;
        } else if (activeFilter === 'Ongoing') {
            return searchMatch && project.withdawalStatus === false && Number(project.targetTime) * 1000 > currentTimestamp;
        } else {
            return false;
        }
    });

    useEffect(() => {
        if (isValid)
            getAllProjects()
        else {
            Error({ text: "Failed!", message: "Please Connect Your Wallet or Switch Network" })
        }
    }, [isValid])

    const handleDonate = async () => {
        try {
            const response = await giveDonation(account.address, currentProject.projectId, donatedValue * (10 ** 18))
            if (response.transactionHash) {
                Success({ text: "Success!", message: "Your amount has been donated" })
            }
            else {
                Error({ text: "Failed!", message: "Something went wrong" })
            }
        }
        catch (error) {
            console.log("��� ~ handleDonate ~ error:", error)
        }
        finally {
            setDonatedValue(null);
            setDonateModalShow(false)
        }
    }

    return (
        <div className='py-32 text-white w-[90%] flex flex-col items-center gap-10'>
            <div className='flex flex-col items-center gap-5'>
                <div>
                    <StyledH6Heading fontColor="text-gradient">Search For Projects</StyledH6Heading>
                </div>
                <div className='md:w-[80%] text-center'>
                    <StyledMdText fontColor="text-white">We have a lot of projects to work on..We have a lot of projects to work on..We have a lot of projects to work on..</StyledMdText>
                </div>
            </div>
            <div className='flex flex-col w-full gap-2 md:flex-row md:gap-3'>
                <div className="flex items-center border border-white rounded-2xl px-4 py-2 md:w-[50%] xl:w-[60%]">
                    <input onChange={(e) => setSearchQuery(e.target.value)} type="text" placeholder="Search..." className="flex-1 px-2 py-1 bg-transparent focus:outline-none" />
                    <img alt="search" src="/assets/images/search.svg" className="w-6 h-6" />
                </div>
                <div className="flex justify-between px-5 border border-white rounded-2xl md:gap-3 md:w-[50%] lg:w-[40%] xl:w-[30%] relative flex-wrap">
                    {filterOptions.map((option, index) => (
                        <button
                            key={index}
                            className={`w-fit px-2 py-2 md:py-0 md:px-4 rounded-2xl ${activeFilter === option ? 'active text-black bg-white' : ''}`}
                            onClick={() => handleFilterClick(option)}
                        >
                            {option}
                        </button>
                    ))}
                </div>
                <div className='lg:w-[10%]'>
                    <Button onClick={handleAddProject} variant="button-gradient" fontColor="flex items-center gap-3 justify-center rounded-xl text-md text-black">
                        Add A Project
                    </Button>
                </div>
            </div>
            {filteredProjects.length === 0 ? (
                <div className='flex flex-col items-center gap-8 pt-10'>
                    <div>
                        <img width={500} height={300} src='/assets/images/nothingFound.webp' alt='Nothing' />
                    </div>
                    <div className='flex flex-col gap-3 text-center'>
                        <div>
                            <StyledXlText fontColor="text-gradient">Nothing found!</StyledXlText>
                        </div>
                        <StyledMdText fontColor="text-white">But Don't Worry, We are continuously validating the best projects for you.</StyledMdText>
                    </div>
                </div>
            ) : (
                <div className='grid grid-cols-1 gap-3 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4'>
                    {
                        filteredProjects.map((project, index) => (
                            <div key={index}>
                                <ProjectsCard project={project} donate={true} />
                            </div>
                        ))
                    }
                </div>
            )}

            {/*Modal show*/}
            {donateModalShow &&
                <div className='w-full h-full'>
                    <Modal>
                        <div className='flex flex-col items-center w-full h-full gap-14'>
                            <div className='flex flex-col gap-2 text-center'>
                                <div>
                                    <StyledXlText fontColor="text-gradient !font-bold">Enter Your Donation Amount.</StyledXlText>
                                </div>
                                <div>
                                    <StyledSmText fontColor="text-white">This amount will be donated to the project : <br /><span className='text-gradient'>" {currentProject.projectName} "</span></StyledSmText>
                                </div>
                            </div>
                            <div className='w-[90%] flex flex-col gap-5'>
                                <div className='grid grid-cols-1 gap-10 md:grid-cols-2'>
                                    <div className='flex flex-col gap-2'>
                                        <div>
                                            <StyledXsText>Project ID</StyledXsText>
                                        </div>
                                        <div>
                                            <input placeholder='Enter Project ID' value={Number(currentProject.projectId)} className='w-full pb-2 bg-transparent border border-b-white border-x-transparent border-t-transparent focus:outline-none' type='text' />
                                        </div>
                                    </div>
                                    <div className='flex flex-col gap-2'>
                                        <div>
                                            <StyledXsText>Amount ( HOPE )</StyledXsText>
                                        </div>
                                        <div>
                                            <input placeholder='0.1' value={donatedValue} onChange={(e) => setDonatedValue(e.target.value)} className='w-full pb-2 bg-transparent border border-b-white border-x-transparent border-t-transparent focus:outline-none' type='text' />
                                        </div>
                                    </div>
                                </div>
                                <div className='w-full'>
                                    <Button onClick={handleDonate} variant="button-gradient" fontColor="flex items-center gap-3 justify-center text-md text-black">Donate Now</Button>
                                </div>
                            </div>
                        </div>
                    </Modal>
                </div>
            }
        </div>
    );
};

export default ProjectsSection;
